<script setup lang="ts">
defineProps<{
	isSuccess?: boolean;
}>();
</script>

<template>
	<div
		:class="{ 'is-success': isSuccess }"
		class="loader relative mx-auto my-0 w-[60px] h-[60px]"
	>
		<svg
			class="circular-loader"
			viewBox="0 0 42 42"
		>
			<g class="loader-group">
				<circle
					class="loader-background stroke-[#e9eef0]"
					cx="21"
					cy="21"
					r="20"
					fill="none"
					stroke-width="2"
				/>
				<circle
					class="loader-path"
					cx="21"
					cy="21"
					r="20"
					fill="none"
					stroke-width="2"
				/>
				<path
					class="loader-check hidden stroke-2 stroke-[#fff]"
					d="M951,540.91l5.37,5.44L969,533.65"
					transform="translate(-939 -519)"
					fill="none"
				/>
			</g>
			<g class="loader-logo-group">
				<path
					class="loader-logo fill-[#ff1d46] transition duration-375 ease-smooth"
					d="M968.31,533.15c-.72.09-1.42.4-2.15.55-1,.2-2.39-.17-2.21-.89.13-.57.75-.72,1.33-.71a2.68,2.68,0,0,1,1.17.34,1,1,0,0,0,1.35-.1,1.5,1.5,0,0,1-.83-.22c-.32-.22-.46-.52-.88-.81a2.1,2.1,0,0,0-2-.11,14.16,14.16,0,0,1-2.56.66,1.92,1.92,0,0,1-1.41-.15,1.25,1.25,0,0,0-.55.78c-.42,1.34-.47,1.55-.75,2.58l-2.47,9.38a5.07,5.07,0,0,0-3.14-1c-2.28,0-4.13,1.23-4.13,2.76s1.84,2.77,4.13,2.77c2.09,0,3.81-1,4.08-2.4l.72-2.73c.58-2.21,1.15-5,1.74-7.16a3.56,3.56,0,0,0,2.06.29c1.11-.1,1.65-1,3.11-.58a3.27,3.27,0,0,1,.69.3,2.12,2.12,0,0,0-2.59-1c-1.42.43-2.61-.41-2.21-1,.55-.78,1.94,0,2.33.08a6,6,0,0,0,2.38.36,5.13,5.13,0,0,0,2-.55,4.11,4.11,0,0,1,2.16-.78,3.35,3.35,0,0,1,1.27.39A2.55,2.55,0,0,0,968.31,533.15Z"
					transform="translate(-939 -519)"
				/>
			</g>
		</svg>
	</div>
</template>

<style lang="scss" scoped>
.loader {

	&.is-success {
		.loader-group {
			@apply animate-none;
		}

		.loader-path {
			animation: path-fill cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
		}

		.loader-background {
			animation: fill 0.1s ease-in-out 0.8s forwards;
		}

		.loader-check {
			@apply block;
		}

		.loader-logo {
			@apply opacity-0;
		}
	}
}

.loader-logo {
	transform-origin: center center;
}

.loader-logo-group {
	transform-origin: center center;
	animation: pulse 2s ease-in-out infinite;
}

.loader-group {
	animation: rotate 2s linear infinite;
	transform-origin: center center;
	@apply h-full w-full absolute top-0 left-0 m-auto;
}

.loader-path {
	stroke-dasharray: 150, 200;
	stroke-dashoffset: -10;
	animation: dash 1.5s ease-in-out infinite;
	stroke-linecap: round;
	@apply stroke-[#ff1d46];
}

@keyframes rotate {
	100% {
		transform: rotate(360deg);
	}
}

@keyframes dash {
	0% {
		stroke-dasharray: 1, 200;
		stroke-dashoffset: 0;
	}
	50% {
		stroke-dasharray: 89, 200;
		stroke-dashoffset: -35;
	}
	100% {
		stroke-dasharray: 89, 200;
		stroke-dashoffset: -124;
	}
}

.loader-check {
	transform-origin: 50% 50%;
	stroke-dasharray: 48;
	stroke-dashoffset: 48;
	animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

@keyframes stroke {
	100% {
		stroke-dashoffset: 0;
	}
}

@keyframes fill {
	100% {
		fill: #19e597;
		stroke: #19e597;
	}
}

@keyframes path-fill {
	0% {
		stroke-dasharray: 1, 200;
		stroke-dashoffset: 0;
	}

	100% {
		stroke-dashoffset: 0;
		stroke-dasharray: 150, 200;
		stroke: #19e597;
	}
}

@keyframes pulse {
	0% {
		transform: scale(1);
	}
	50% {
		transform: scale(0.9);
	}
	100% {
		transform: scale(1);
	}
}
</style>
